module.exports = __webpack_public_path__ + "img/Back.e0a72590.svg";